import ReverseMatchList from "./list";

const reverseMatchComponents = {
  list: ReverseMatchList,
};

export default reverseMatchComponents;
